"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getDefinables_1 = __importDefault(require("./getDefinables"));
const getDefinable = ({ className, slug }) => {
    const definables = (0, getDefinables_1.default)(className);
    const entry = definables.get(slug);
    if (typeof entry !== "undefined") {
        return entry;
    }
    throw new Error(`${className} "${slug}" could not be found.`);
};
exports.default = getDefinable;
